import useRegularClass from "src/hooks/useRegularClass";
import { z } from "zod";
import moment from "moment";
import { Form } from "src/components/common/form";
import { Input } from "src/components/common/form/input";
import { Select } from "src/components/common/form/select";
import { Button } from "react-bootstrap";
import { RegularClassScheduleSelect } from "./regular-class-schedule-select";

const attendanceFilterSchema = z.object({
  attendance_date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "日付を入力してください"),
  regular_class_id: z.coerce.number().min(1, "クラスを選択してください"),
  regular_class_schedule_id: z.coerce
    .number()
    .min(1, "スケジュールを選択してください"),
});

export const AttendanceFilter = ({ onSubmit }) => {
  const regularClass = useRegularClass();

  return (
    <Form
      onSubmit={values => {
        onSubmit(values);
      }}
      schema={attendanceFilterSchema}
      options={{
        defaultValues: {
          attendance_date: moment().format("YYYY-MM-DD"),
          regular_class_id: 0,
          regular_class_schedule_id: 0,
        },
      }}
    >
      {({ register, watch, formState }) => {
        let regularClassOptions = [{ value: 0, label: "選択してください" }];

        if (watch("attendance_date")) {
          regularClassOptions = [
            ...regularClassOptions,
            ...regularClass.list
              .filter(cls => ["Ａ"].includes(cls.affiliation_name))
              .map(cls => ({
                value: cls.id,
                label: cls.affiliation_name,
              })),
          ];
        }

        return (
          <>
            <div className="d-flex gap-2 flex-wrap">
              <Input
                type="date"
                label="日付"
                name="attendance_date"
                error={formState.errors["attendance_date"]}
                registration={register("attendance_date")}
              />
              <Select
                label="クラス"
                options={regularClassOptions}
                name="regular_class_id"
                error={formState.errors["regular_class_id"]}
                registration={register("regular_class_id")}
                readOnly={!watch("attendance_date")}
              />
              <RegularClassScheduleSelect />
            </div>
            <div className="d-flex">
              <Button type="submit">検索</Button>
            </div>
          </>
        );
      }}
    </Form>
  );
};
